import React from 'react';
import RenderAvatarPP from './render_avatar_pp';

export default (props) => {
  
        return (  <div className="communication-comment">
                    <div className="author author-with-link author-with-marker" id={`comentario_post_${props.id}`}>
                        <div className="author-avatar">
                          <RenderAvatarPP Foto={props.foto}/>
                        </div>
                    </div>
                    <div className="communication-comment-content">
                        <div className="communication-comment-content-author author-with-link">
                             <span>{props.nome}</span>

                        </div>
                        <div className="communication-comment-content-text">
                              {props.use_id === props.use_id_com ? props.funcao : "" } 
                              {props.coment}
                        </div>
                    </div>
                </div>);
}
// return (<div className="panel">
// <div className="panel-body post-form">
//     <div id={`comentario_post_${props.id}`} >
//         <div className="post-form-foto">
//             <RenderAvatarPP Foto={props.foto}/>
//         </div>
//         <div className="post-form-container comentario">
//             <p>
//                 <span>{props.nome}</span>
//                 {props.use_id === props.use_id_com ? props.funcao : "" } 
//             </p>
//             {props.coment}
//         </div>
//     </div>
// </div>
// </div>);

 




// WEBPACK FOOTER //
// ./src/container/renderComentarioPost.js